export const MEDIA_TYPES = {
  TABLET: 'tablet-portrait',
  PHONE: 'phone',
  DESKTOP: 'desktop',
  UNKNOWN: 'unknown',
};
